import { View } from "react-native";
import ContentLoader, { Rect } from "react-content-loader/native";
import { Spacer } from "components/spacer";

export function OrganizationMobileSkeleton() {
  return (
    <View>
      <ContentLoader
        speed={2}
        width="100%"
        height={50}
        backgroundColor="#f7f7f7"
        foregroundColor="#ecebeb"
      >
        <Rect width="100%" height="50px" />
      </ContentLoader>
      <Spacer size={8} />
      <ContentLoader
        speed={2}
        width="100%"
        height={50}
        backgroundColor="#f7f7f7"
        foregroundColor="#ecebeb"
      >
        <Rect width="100%" height="50px" />
      </ContentLoader>
      <Spacer size={8} />
      <ContentLoader
        speed={2}
        width="100%"
        height={50}
        backgroundColor="#f7f7f7"
        foregroundColor="#ecebeb"
      >
        <Rect width="100%" height="50px" />
      </ContentLoader>
    </View>
  );
}
